<template>
  <v-container>
    <h2>
      Please provide an estimate of your current credit score:
    </h2>

    <p>
      LendingWell will never ask to pull your credit, this question is
      designed to ensure you are matched with the right lending partner based
      on each lender's financing guidelines.
    </p>

    <div class="option-wrapper column">
      <button
        v-for="(item, index) in creditScores"
        :key="`credit-score-${index}`"
        class="default-btn blue"
        @click.prevent="onCreditScoreSelect(item.name)"
      >
        {{ item.title }}
        <span>{{ item.range }}</span>
      </button>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'QuestionnaireCreditScoreStep',
  computed: {
    ...mapState('questionnaireStore', {
      creditScores: ({ questions }) => questions ? questions.creditScores : [],
    }),
  },
  methods: {
    ...mapActions('questionnaireStore', ['updateMatchData']),
    async onCreditScoreSelect (item) {
      await this.updateMatchData({ creditScore: item })
      this.$emit('finished')
    },
  },
}
</script>

<style lang="scss" scoped></style>
